<div [formGroup]="form" class="flex flex-col gap-3 p-4">
    <textarea rows="5" cols="30" pTextarea formControlName="noteIndagineVisiva" class="w-full" placeholder="Note indagine visiva"></textarea>
</div>
